/*
Deckster
by Gabriel Caterson
01/02/18
A genetic algorithm designed to find decent decks in the popular mobile game Clash Royale.*/
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './Components/App';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
  <App />,
  document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js